<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <!-- <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="菜单名称">
              <a-input v-model="queryParam.name" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="父级菜单">
              <a-select
                showSearch
                :filterOption="filterOption"
                v-model="queryParam.parentId"
                default-value="0"
                placeholder="请选择">
                <a-select-option v-for="(item, index) in menuSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button type="dashed" v-if="config.hasAlert" @click="tableOption">{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div> 

    <!-- 数据网格 -->
    <a-table 
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :dataSource="treeData">
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical"/>
        <a @click="handleDel(record)">删除</a>
      </span>
    </a-table>

    <a-modal title="编辑" style="top: 20px;" :width="560" v-model="visible" @ok="handleOk" :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="菜单名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.name"
            placeholder="菜单名称"
            v-decorator="['name',
            { initialValue: mdl.name, rules: [{ required: true, message: '请输入菜单名称'}]}]" />
        </a-form-item>

        <a-form-item label="菜单路由" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.url"
            placeholder="菜单路由"/>
        </a-form-item>

        <a-form-item label="父级菜单" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="mdl.parentId"
            placeholder="请选择父级菜单"
            v-decorator="['parentId',
            { initialValue: mdl.parentId, rules: [{ required: true, message: '请选择父级菜单'}]}]">
            <a-select-option value="0">0（一级菜单的父级菜单统一选择0）</a-select-option>
            <a-select-option v-for="(item, index) in menuSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="菜单等级" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number 
            :min="1" :max="3"
            v-model="mdl.level" 
            placeholder="菜单等级" 
            v-decorator="['level',
            { initialValue: mdl.level, rules: [{ required: true, message: '请输入菜单等级'}]}]" style="width: 100%"/>
        </a-form-item>

        <a-form-item label="同级排序" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number 
            :min="0" :max="1000"
            v-model="mdl.sort" 
            placeholder="同级排序" 
            v-decorator="['sort',
            { initialValue: mdl.sort, rules: [{ required: true, message: '请输入同级排序'}]}]" style="width: 100%"/>
        </a-form-item>

      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { menuPage, menuUpdate, menuSave, menuDelete, menuList, menuTree } from '@/api/sys'

export default {
  name: 'Privillege',
  components: {
    STable
  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      treeData: [],
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '菜单名称',
          dataIndex: 'name'
        },
        {
          title: '菜单路由',
          dataIndex: 'url'
        },
        {
          title: '菜单级别',
          dataIndex: 'level'
        },
        {
          title: '同级排序',
          dataIndex: 'sort'
        },
        {
          title: '父级菜单',
          dataIndex: 'parentName'
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 所属菜单下拉
      menuSelect: null,
      // 加载数据方法 必须为 Promise 对象
      // loadData: parameter => {
      //   return menuPage(Object.assign(parameter, this.queryParam))
      //     .then(res => {
      //       return res.data
      //     })
      // },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created () {
    this.tableOption()
    this.loadMenuSelect()
  },
  methods: {
    loadMenuSelect () { // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = menuList({ }).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.menuSelect = res
      })
      new Promise(resolve => {
        const data = menuTree({ }).then(res => { return res.data })
        resolve(data)
      }).then(res => {
          console.log(res)
        this.treeData = res
      })
    },
    filterOption (input, option) { // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit (record) {
      this.form = this.$form.createForm(this)
      this.mdl = Object.assign({}, record)
      this.visible = true
    },
    handleAdd () {
      this.form = this.$form.createForm(this)
      this.mdl = {}
      this.visible = true
    },
    handleOk () {
      console.log(this.mdl)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            menuUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.loadMenuSelect()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          } else {
            menuSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.loadMenuSelect()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel (record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk () {
          nthis.confirmLoading = true
          return menuDelete({ 'ids': record.id })
            .then(res => {
              if(res.code ==='0') {
                //nthis.$refs.table.refresh()
                nthis.loadMenuSelect()
              }
            }).catch((e) => {
              console.log(e)
            }).finally(() => {
              nthis.confirmLoading = false
            })
        },
        onCancel () {
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>
